import React, { useEffect, useState, useCallback } from "react";
import { Link} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPenToSquare, faTrashCan} from '@fortawesome/free-solid-svg-icons';
import {faXmark, faFileExcel} from '@fortawesome/free-solid-svg-icons';
import { getAdminSubscription } from '../../Service';
import { deleteSubscription } from '../../Service';
import Swal from "sweetalert2";
import ReactPaginate from 'react-paginate';
import PaginatedItems from './Pagination';
import moment from 'moment';

export default function SubscriptionList(){
    //const auth =Auth();
    //console.log(auth);

    const [subscriptionData, setSubscriptionData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [perPage, setPerPage] = useState(100);
    const [curPage, setCurPage] = useState(1);
    const [totalRec, setTotalRec] = useState(0);

    /** ------------------------ Pagination States -------------- */
    const data = subscriptionData;
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [itemsPerPage, setitemsPerPage] = useState(0);
 /** ------------------------ Pagination States -------------- */

    useEffect(() => {
        let params = { 'perPage': perPage, 'curPage': curPage, 'admin_list': 1 };
        getAdminSubscription(params).then(res => handleResponse(res))
      }, [curPage]);


      const handleResponse = (response) => {
        console.log(response);
        if(response.data.code==400){ //IF Token Expired......
            const errors = {};
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: response.data.message,
            })
          }else if(response.data.code==200){  //IF Request is Success
            setSubscriptionData(response.data.data.subscription.items);
            setTotalRec(response.data.data.subscription.total);
            setitemsPerPage(10); //SET LIST OF RECORDS PER PAGE.
          }
      }

/** ------------------------ Pagination Start Here ------------------------  */
      useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(data.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(data.length / itemsPerPage));
      }, [itemOffset, itemsPerPage]);

      
      const handlePageClick = useCallback ((event) => {
        const newOffset = (event.selected * itemsPerPage) % data.length;
        setItemOffset(newOffset);
        console.log(newOffset);
      });
  /** ------------------------ Pagination Ends Here ------------------------  */
  
      const doDelete = (subscription_id)=> {
        
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want delete this subscription?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) {
                let params = { 'id': subscription_id };
                deleteSubscription(params).then(res => handleDeleteRes(res, subscription_id))
            }
          })
        
    }
  
    const handleDeleteRes = (response, subscription_id) => {
        console.log(response);
        if(response.data.code==400){ //IF Token Expired......
            const errors = {};
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: response.data.message,
            })
          }else if(response.data.code==200){  //IF Request is Success
            let allsubscriptionData = currentItems;
            let filteredArray =  allsubscriptionData.filter(item => item.id !== subscription_id);
            setCurrentItems(filteredArray);
            setTotalRec(totalRec-1);
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Subscription Deleted Successfully',
                showConfirmButton: false,
                timer: 1500
              })
          }
      }

      return (
        <>
        <section className="admin-section">
        <div className="container">
        <div className="row">
        <div className="col-12">
          <div className="card admin-table">
            <div className="card-header">
            <h1>({totalRec}) SUBSCRIPTIONS </h1>
            <Link to="/admin-subscriber" style={{marginLeft: '7px;'}} className="add-event">Subscriber List</Link> 
            <Link to="/add-subscription" className="add-event">+ Add Subscription</Link>     
            </div>
            <div className="card-body">
                <div className="table-responsive">
            <table className="table">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Validity</th>
                    <th>Price</th>
                    <th>Created Date</th>
                    <th> </th>
                </tr>
            </thead>
            <tbody>
            {
                
                currentItems.map( data => (
                <tr key={data.id}>
                    <td>
                      {data.sub_name}
                    </td>   
                      
                    <td>
                        {(() => {
                            if(data.sub_validity==1){
                                return (
                                    <>Annually</>
                                )
                            }else if(data.sub_validity==2){
                              return (
                                  <>Half-Yearly</>
                              )
                            }else if(data.sub_validity==3){
                              return (
                                  <>Quarterly</>
                              )
                            }else if(data.sub_validity==4){
                              return (
                                  <>Monthly</>
                              )
                            }
                    })()}
                    </td> 
                      
                    <td>
                      ${data.sub_price}
                    </td>    

                    <td>
                      {moment(data.created_at).format("MM-DD-YYYY")}
                    </td> 
                  <td>      
                    <Link to={ `/edit-subscription/${data.id}` }><FontAwesomeIcon icon={faPenToSquare} /></Link>
                     / <a href="javascript:void(0);" onClick={()=> doDelete(data.id)}><FontAwesomeIcon icon={faTrashCan} /></a>
                  </td>
                </tr> 
        ))
      }
        
        </tbody>
        </table> 
        
        
        </div>
            </div>
            <div className="card-footer">
              <ReactPaginate
                    breakLabel="..."
                    nextLabel="Next"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="Previous"
                    renderOnZeroPageCount={null}
                    className="admin-paginate"
              />
            </div>
        </div>
        </div>
        </div>
        </div>  
        </section>
                
              </>
            );
}
